import { getAmpConfig } from 'src/services/amp-config.service';
import AuthService from 'src/services/api/auth.service';
import { getValueOf } from 'src/utils/date.utils';

export const findInsightByContentBk = <
  T extends { insight_content: { instanceId?: string } },
>(
  contentOrCardstackKey: string | undefined,
  insights: T[] = [],
) =>
  insights.find(
    (insight) => insight.insight_content.instanceId === contentOrCardstackKey,
  );

export const findInsightByLessonKey = <
  T extends { insight_content: { url?: string } },
>(
  lessonKey: string | undefined,
  insights: T[] = [],
) =>
  insights.find((insight) => {
    if (!lessonKey) return false;

    return insight.insight_content.url?.includes(lessonKey);
  });

export const isDesmosFeedback = (feedbackUrl: string) => {
  const isTeacher = AuthService.isTeacher();
  const teacherDesmosUrl = getAmpConfig().desmosTeacher;
  const studentDesmosUrl = getAmpConfig().desmosStudent;

  const desmosUrl = isTeacher ? teacherDesmosUrl : studentDesmosUrl;

  return feedbackUrl.startsWith(desmosUrl);
};

export const isNotificationSupportingReadStatus = (
  notificationTimestamp: number,
) => {
  // Months are 0-indexed, so 2 represents March
  const readStatusReleaseDate = new Date(2025, 2, 20);

  return notificationTimestamp > getValueOf(readStatusReleaseDate);
};
